import { useEffect, useState } from "react";
import type { AbsoluteProps } from "./Absolute.types";

export const useAbsolute = ({
  to,
  position,
  align,
}: Pick<AbsoluteProps, "align" | "position" | "to">): {
  computedX: string;
  computedY: string;
} | null => {
  const [, setDomRect] = useState<undefined | DOMRect>();

  useEffect(() => {
    const callback = () => {
      if (to) setDomRect(to.getBoundingClientRect());
    };

    window.addEventListener("scroll", callback, { passive: true, capture: false });

    return () => {
      window.removeEventListener("scroll", callback);
    };
  }, [to]);

  if (!to) return null;

  const { x, height, y, width } = to.getBoundingClientRect();

  const style = {
    computedY: "",
    computedX: "",
  };

  let fixedProperty: "computedY" | "computedX" = "computedY";
  let unFixedProperty: "computedY" | "computedX" = "computedX";
  let fixedAxisValue = y;
  let fixedRelativeValue = height;
  let alignAxisValue = x;
  let alignRelativeValue = width;

  if (position === "left" || position === "right") {
    fixedProperty = "computedX";
    unFixedProperty = "computedY";
    fixedAxisValue = x;
    fixedRelativeValue = width;
    alignAxisValue = y;
    alignRelativeValue = height;
  }

  if (position === "left" || position === "top")
    style[fixedProperty] = `calc(-100% + ${fixedAxisValue}px)`;
  else style[fixedProperty] = `${fixedAxisValue + fixedRelativeValue}px`;

  if (align === "start") {
    style[unFixedProperty] = `${alignAxisValue}px`;
  }

  if (align === "center") {
    style[unFixedProperty] = `calc(${alignAxisValue + alignRelativeValue / 2}px - 50%)`;
  }

  if (align === "end") {
    style[unFixedProperty] = `calc(${alignAxisValue + alignRelativeValue}px - 100%)`;
  }

  return style;
};
